import Decimal from 'decimal.js';

export default function fromDecimal(value?: number | string | Decimal): number {
  if (!value) {
    return 0;
  }

  if (value instanceof Decimal) {
    return value.toNumber();
  }

  if (typeof value === 'number') {
    return value;
  }

  return new Decimal(value).toNumber();
}
